// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"9e731a15","559":"c67abe4f","564":"74a5153a","916":"74a5153a"}[chunkId] + ".chunk.css";
};